import { React, useState, useContext, useRef} from "react";
import { useParams, matchPath, useLocation } from "react-router-dom";
import AddNote from "../../../Pages/addNote";

import {
    descriptionCharLimit,
    exportPdf,   
} from "../../../Config/config";
import CompanyLogo from "../../../Components/CompanyLogo";
import RandomLogo from "../../../Components/RandomLogo";
import AlertPopUp from "../../../Components/DetailPage/AlertPopUp";
import PENotesPopup from "../../../Components/NotesPopup/PENotesPopup";
import SendDealPopUp from "../../SendDealPopUp";
import XLSPopup from "../../../Components/DetailPage/DownloadXLS";
import PdfDownloader from "../../shared/PdfDownloader";
import { RaiseRequestContext } from '../../../Contexts/RaiseRequestContext'
import Constants from "../../../Constants";
import { Tooltip } from "antd";
import routePathSegments from "../../../routeSegments";
import AddNotePopover from "../../shared/AddNotePopover";
import ReactReadMoreReadLess from "react-read-more-read-less";
import { UserContext } from "../../../Contexts/UserContext";
import useModule from '../../../hooks/useModule'

const CompanyDetailInformation = (props) => {
    console.log(props?.section,"abcd");
    const { openRequestPopup } = useContext(RaiseRequestContext)    
    const [showAdd, setShowAdd] = useState(false);    
    const { companyId } = useParams();
    let companyProfileId = parseInt(companyId);
    const [note, setNote] = useState(false);    
    const location = useLocation();
    const {isMA, isRE, isVC } = useModule();
    const isReMatch = matchPath(`${routePathSegments.re}/*`, location.pathname)
    const {isTrialExport,isStudent} = useContext(UserContext)

   /* The above code is written in JavaScript and it is creating a list of tags based on the data
   provided in the props object. */
    const tagsList = props?.data?.tags?.split(",").map((tag) => {
        const capital = tag.charAt(0).toUpperCase() + tag.slice(1);
        return (
            <li className="mt-2 lg:mt-0 nav-item flex active " role="presentation">
                {capital ? (
                    <a className=" lg:block text-[10.7pt] leading-[17pt] lg:leading-[16px] font-sans_book_body px-3 mr-2 py-1 text-center text-[#333333] bg-[#EFEFEF] lg:text-[12px] rounded-[5px]">
                        {capital}
                    </a>
                ) : null}
            </li>
        );
    });


    const menuRef = useRef();

    // console.log(tagsList, "tagslist")

  /* The above code is assigning the value of `props?.data?.moreInformation` to the `longText` variable
  if `props?.page` is equal to "redealPage". Otherwise, it assigns the value of
  `props?.data?.business_desc` to the `longText` variable. The `?.` operator is used for optional
  chaining, which allows accessing nested properties without causing an error if any of the
  intermediate properties are null or undefined. */
    let longText =
        props?.page == "redealPage" 
            ? props?.data?.moreInformation
            : props?.data?.business_desc;
    // console.log(longText,"moreinfo");
    const charLength = descriptionCharLimit;


    /* The above code is a conditional statement that determines the value of the `component` variable
    based on the value of the `props.activeTab` and the `isReMatch` variables. */
    const component = props?.activeTab == "re-investments" ? isReMatch != null ? "moreInfoInvestment" : "moreDealVc"
        : props?.activeTab == "re-ipo" ? "moreInfoIncubation"
            : props?.activeTab == 're-exits' ? "moreInfoIncubation"
                : props?.activeTab == 'other-manda' ? "moreInfoIncubation"
                    : isReMatch != null ? "moreInfoInvestment" : "moreDealVc"

    // console.log('props?.activeTabs', props?.activeTab,);

  /**
   * The function `subTypeMasterId` returns a subcategory ID based on the value of the `props.section`
   * variable.
   * @returns the subTypeMasterId based on the value of the props.section.
   */
    const subTypeMasterId =() =>{
       
        if(props?.section == Constants.primaryMasterSubIds.re_investments_id){
          return Constants.subCategoryIds.re_investments_id
        }
        else if(props?.section == Constants.primaryMasterSubIds.re_exits_id){
          return Constants.subCategoryIds.re_exitsma_id
        }
        
        else if(props?.section == Constants.primaryMasterSubIds.re_others_ma_id){
          return Constants.subCategoryIds.re_others_ma_id
        }
        else if(props?.section == Constants.primaryMasterSubIds.re_backed_ipos_id){
          return Constants.subCategoryIds.re_backed_ipos_id
        }
        
      } 
    return (
        <>
            <div>
                <div className="px-5 ">
                    <div className="lg:hidden mt-4  grid  md:grid-cols-8  grid-cols-10  items-center mb-4">
                        <div className="col-span-5 mt-2">

                        </div>

                        <div className="flex md:col-span-2 col-span-5 space-x-3">
                            <div className="col-span-1 ">
                                <AlertPopUp cid={props.id} type_id={1} />{" "}
                            </div>
                          {props?.page == "redealPage" ? <></> :  <div className="col-span-1" ref={menuRef}>
                                <span>
                                    <Tooltip title="Save List">
                                        <AddNotePopover companyId={props.id} companyName={props?.data?.company_name ?? ""} type_id={Constants.moduleIds.companiesId} sub_type_master_id={subTypeMasterId()}/>
                                    </Tooltip>

                                </span>
                            </div>
                          }

                            <div className="col-span-1 lg:mt-1">
                                <PENotesPopup
                                    note={note}
                                    cid={props.id}
                                    type_id={Constants.moduleIds.companiesId}
                                />
                            </div>
                            <div className="col-span-1">
                                <SendDealPopUp data={props?.data?.company_name} />
                            </div>
                            
                            {isStudent == 'true' ? <></> :
                                                    <div className="col-span-1 ">
                                                        {
                                                            props?.page == "redealPage" ? (
                                                                isTrialExport != 'false' && 
                                                                <XLSPopup activeTab={props?.activeTab} exportFileName={props.exportFileName} />
                                                            ) : (
                                                                <PdfDownloader
                                                                    url={exportPdf}

                                                                    fileName={props?.page == "redealPage"
                                                                        ? props?.data?.companyname?.replaceAll(/\s/g, "")
                                                                        : props?.data?.company_name?.replaceAll(/\s/g, "")
                                                                    }

                                                                    data={{
                                                                        "module_type": "RE",
                                                                        "entity_id": companyProfileId,
                                                                        "type_id": Constants.moduleIds.companiesId,
                                                                        "type": 3,
                                                                        "is_detailed": true,

                                                                    }}


                                                                />
                                                            )
                                                        }

                                                    </div>
                                                    }
                            <div >
                                {/* <img className=" w-5 h-6" src={pdf} alt="" /> */}
                                
                            </div>
                        </div>
                    </div>
                    <div className="   bg-[#FFFFFF]">
                        <ul role="list">
                            {Object.keys(props?.data ?? {}).length > 0 ? (
                                <>
                                    <li className="w-full flex pt-0 md:pt-6 bg-[#FFFFFF]">
                                        <div className=" rounded-md">
                                            {props?.page == "reCompanyPage" ?
                                                props?.data?.logo == "default.png" || props?.data?.logo == "/default.png" || !props?.data?.logo ?
                                                    <RandomLogo name={props?.data?.company_name} page="detail page" />
                                                    :
                                                    <CompanyLogo name={props?.data?.company_name} id={props?.id} page="detail page" logo={props?.data?.logo} />

                                                :
                                                props?.data?.logo_path == "default.png" || props?.data?.logo_path == "/default.png" || !props?.data?.logo_path ?
                                                    <RandomLogo name={props?.data?.companyname} page="detail page" />
                                                    :
                                                    <CompanyLogo name={props?.data?.companyname} id={props?.id} page="detail page" logo={props?.data?.logo_path} />

                                            }
                                        </div>

                                        <div className="ml-3 flex flex-1 flex-col">

                                            <p
                                                className="text-[#333333] text-[22px] font-semibold leading-[24px]"

                                            >
                                                {" "}
                                                {props?.page == "redealPage" ? props?.data?.companyname : props?.data?.company_name}{" "}
                                            </p>

                                            <span className="text-[11pt] leading-[15pt]  text-[#777777] lg:text-[13px] font-sans_book_body lg:leading-[21px]">
                                                {props?.page == "dealPage" ? props?.data?.projectname : props?.data?.projectname}
                                            </span>
                                            <span className=" text-[12pt] leading-[16pt] text-[#333333]  lg:text-[13px] lg:leading-[17px]  ">

                                                {props.page == "recompanyPage" ? props?.data?.company_type : props?.data?.company_type}
                                            </span>
                                        </div>

                                        <div className="hidden lg:grid grid-cols-8 gap-2 ">
                                            <div className="col-span-3 mt-2">
                                                {/* <Tooltip title="Compare Company" >
                                                        <button

                                                            className={
                                                                showModal
                                                                    ? "bg-[#BC8B20] text-white text-[13px] py-1 lg:py-1 px-2 lg:px:4 border border-[#BC8B20] rounded-[4px] inline-flex items-center font-sans_book_body"
                                                                    : "bg-[#FFFFFF] text-[#666666] text-[13px] py-1 lg:py-1 px-2 lg:px:4 border border-[#DDDDDD] rounded-[4px] inline-flex items-center font-sans_book_body"
                                                            }
                                                            type="button"
                                                            onClick={() => {
                                                                setShowModal(!showModal)
                                                                setCompanyDetail([])
                                                                setCurrentPage("company")
                                                            }
                                                            }
                                                        >
                                                            <img

                                                                className={
                                                                    showModal
                                                                        ? "brightness-0 invert-[1] w-[20px] h-[18px] pr-1"
                                                                        : "w-[20px] h-[18px] pr-1 blur-btn"
                                                                }
                                                                src={compare}
                                                                alt=""
                                                            />
                                                            <span>Compare</span>
                                                        </button>
                                                    </Tooltip> */}
                                            </div>
                                            <div className="col-span-5 mt-[5px] ml-2">
                                                <div className={props?.page == "redealPage" ?"grid grid-cols-4 gap-2 flex items-center":"grid grid-cols-5 gap-2 flex items-center"}>
                                                    <div className="col-span-1 ">
                                                        <AlertPopUp cid={props.id} type_id={Constants.moduleIds.companiesId} />{" "}
                                                    </div>

                                                    {props?.page == "redealPage" ? <></> :<div className="col-span-1" ref={menuRef}>
                                                        <span>

                                                            <AddNotePopover
                                                                title="Save List"
                                                                companyId={props.id}
                                                                companyName={props?.page == "redealPage" ? props?.data?.companyname : props?.data?.company_name}
                                                                type_id={Constants.moduleIds.companiesId} IsDetailed={true} 
                                                                sub_type_master_id={subTypeMasterId()}
                                                                />


                                                        </span>
                                                    </div>
                                                        }
                                                    <div className="col-span-1 mt-1">
                                                        <PENotesPopup
                                                            note={note}
                                                            cid={props.id}
                                                            type_id={Constants.moduleIds.companiesId}
                                                        />
                                                    </div>
                                                    <div className="col-span-1 mt-1">
                                                        <SendDealPopUp data={props?.page == "redealPage" ? props?.data?.companyname : props?.data?.company_name} />
                                                    </div>
                                                    {isStudent == 'true' ? <></> :
                                                    <div className="col-span-1 mt-1">
                                                        {
                                                            props?.page == "redealPage" ? (
                                                                isTrialExport != 'false' && 
                                                                <XLSPopup activeTab={props?.activeTab} exportFileName={props.exportFileName} />
                                                            ) : (
                                                                <PdfDownloader
                                                                    url={exportPdf}

                                                                    fileName={props?.page == "redealPage"
                                                                        ? props?.data?.companyname?.replaceAll(/\s/g, "")
                                                                        : props?.data?.company_name?.replaceAll(/\s/g, "")
                                                                    }

                                                                    data={{
                                                                        "module_type": "RE",
                                                                        "entity_id": companyProfileId,
                                                                        "type_id": Constants.moduleIds.companiesId,
                                                                        "type": 3,
                                                                        "is_detailed": true,

                                                                    }}


                                                                />
                                                            )
                                                        }

                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>

                                        {props?.data?.tags && props?.data?.tags != "" &&
                                            <div className="bg-[#FFFFFF] mt-4">
                                                <ul
                                                    className="nav nav-tabs flex flex-wrap  list-none border-b-0 pl-0 mb-2"
                                                    id="tabs-tab"
                                                    role="tablist"
                                                >
                                                    {tagsList}
                                                </ul>
                                            </div>
                                        }
                                        <div className="">

                                            {longText != "" ? (
                                                <>
                                                    <p className="whitespace-pre-line text-[11pt] leading-[18pt] py-1  lg:text-[14px] text-[#333333] lg:leading-[20px] font-sans_book_body">
                                                        {props?.activeTab == "re-investments" ||
                                                            props?.activeTab == "re-ipo" ||

                                                            props?.activeTab == "re-exits" ? (
                                                            <p className="text-[11pt] leading-[18pt] py-2 lg:text-[14px] text-[#333333] lg:leading-[20px] font-sans_roman_body ">
                                                                Deal Details:
                                                            </p>
                                                        ) : props?.page == "reCompanyPage" ? (
                                                            " "
                                                        ) : (
                                                            <p className="text-[11pt] leading-[18pt] py-2 lg:text-[14px] text-[#333333] lg:leading-[20px] font-sans_roman_body ">
                                                                Ipo Structure:
                                                            </p>
                                                        )}
                                                        <ReactReadMoreReadLess
                                                            charLimit={charLength}
                                                            readMoreText={"View More "}
                                                            readLessText={"View Less "}
                                                            readMoreClassName="read-more-less--more lg:text-[13px]"
                                                            readLessClassName="read-more-less--less lg:text-[13px]"
                                                        >
                                                            {longText ?? ""}
                                                        </ReactReadMoreReadLess>
                                                        {props?.page == "reCompanyPage" || props.page === "redealPage" ? (
                                                            " "
                                                        ) : (
                                                            <p className="mt-2">
                                                                {/* <button className='text-[#A5711A] hover:underline' onClick={()=>openRequestPopup(component)}>Click Here</button> */}
                                                                {props?.activeTab == "re-investments" ?
                                                                    <>
                                                                        <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(component)}>Request more information</button>&nbsp;
                                                                        specifying what details you would like. Note: For recent transactions, regulatory filing based information is typically less than that for older ones.
                                                                    </>
                                                                    : props?.activeTab == 're-ipo' ?
                                                                        <>
                                                                            <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(component)}>Click Here</button>&nbsp;
                                                                            to request more details for this deal.
                                                                        </>
                                                                        : props?.activeTab == 're-exits' ?
                                                                            <>
                                                                                <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(component)}>Request more information</button>&nbsp;
                                                                                specifying what details you would like.
                                                                            </>
                                                                            : props?.activeTab == "other-manda" ?
                                                                                <>
                                                                                    <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(component)}>Click Here</button>&nbsp;
                                                                                    to request more details (financials, valuations, etc.) to the extent available for this deal.
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(component)}>Request more information</button>&nbsp;
                                                                                    specifying what details you would like. Note: For recent transactions, regulatory filing based information is typically less than that for older ones.
                                                                                </>
                                                                }</p>
                                                        )}
                                                    </p>
                                                </>
                                            )
                                                :
                                                ""
                                            }
                                        </div>

                                    </li>
                                </>
                            ) : (
                                <div className="w-full bg-[#FFFFFF]">
                                    <center>
                                        <div role="status" className=" h-[8rem]">
                                            <svg
                                                className="relative top-[4rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                                                viewBox="0 0 100 101"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor"
                                                />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill"
                                                />
                                            </svg>
                                        </div>
                                    </center>
                                </div>
                            )}
                            {showAdd ? <AddNote id={companyProfileId} /> : ""}
                        </ul>
                    </div>
                    
                </div>
            </div>

        </>
    );
};

export default CompanyDetailInformation;
